import React from "react";

import {
  ReferenceIssues,
  ReferenceOnePagePortfolioAssessmentIssue,
} from "../../../../state";

import styles from "./Reference.module.scss";

export type ReferenceProps = {
  title: string;
  referenceData: (ReferenceIssues | ReferenceOnePagePortfolioAssessmentIssue)[];
};

const Reference: React.FC<ReferenceProps> = ({ title, referenceData }) => {
  return (
    <div className={styles.reference}>
      <p className={styles.title}>{title}</p>
      <ul className={styles.list}>
        {referenceData.map(reference => {
          if ("issues" in reference) {
            return (
              <li key={reference.id} className={styles.item}>
                <p className={styles.subject}>
                  {reference.name} {reference.title}
                  {reference.issues.map(issue => (
                    <span
                      key={issue.lesson_keyword_id}
                      className={styles.keyword}
                    >
                      keyword {issue.lesson_keyword_name}
                    </span>
                  ))}
                </p>
                <ul className={styles.answerList}>
                  {reference.issues.map(issue =>
                    issue.questions.map(question => (
                      <li key={question.id} className={styles.answerItem}>
                        {!!question.answers && question.answers.length > 0
                          ? question.answers.map(answer => answer.contents)
                          : "回答データがありません。"}
                      </li>
                    )),
                  )}
                </ul>
              </li>
            );
          } else {
            return reference.questions.map(question => (
              <li key={question.id} className={styles.item}>
                <p className={styles.subject}>{question.title}</p>
                <ul className={styles.answerList}>
                  <li key={question.id} className={styles.answerItem}>
                    {question.answers?.contents || "回答データがありません。"}
                  </li>
                </ul>
              </li>
            ));
          }
        })}
      </ul>
    </div>
  );
};

export default Reference;
